<template>
  <f7-page no-toolbar no-swipeback name="activity" class="page-messgae-center" @page:init="onPageInit()" >
    <f7-navbar innerClass="navbar-inner-message">
      <f7-nav-left>
        <f7-link @click="$f7router.back()">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title >{{ withdrawPageRemark.CharityNewsTitle?withdrawPageRemark.CharityNewsTitle:'' }}</f7-nav-title>
      <f7-nav-right>
        <f7-link></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div style="padding: 10px;">
      <div v-html="withdrawPageRemark.CharityNewsRemark?withdrawPageRemark.CharityNewsRemark:''"></div>
    </div>
    
  </f7-page>
</template>


<script>
import { getCookie,getStore } from "@/config/utils";
import { getwebsiteinfoGet } from "../../axios/api";

export default {
  components: {},
  props: {},
  data() {
    return {
      withdrawPageRemark: {},
    };
  },
  watch: {},
  computed: {
  },
  methods: {
    onPageInit(){
      getwebsiteinfoGet().then((data) => {
      if (data.Code == "NoError") {
          this.withdrawPageRemark = data.Data;
        }
      });
    }
  },
  created() {

  },
  mounted() {
  },
  beforeDestroy() {
  },
};
</script>
<style lang="less" scoped>

</style>
